import { XCircleIcon } from "@heroicons/react/24/outline";

type ErrorDisplayProps = {
  message: string;
  onClick: () => void;
};

const ErrorDisplay = (props: ErrorDisplayProps) => {
  return (
    <div className="bg-red-400 text-white flex justify-center items-center font-semibold tracking-[0.07rem]">
      <div className="container flex-grow flex items-center justify-center p-4">
        <div className="px-6">{props.message}</div>
        <button
          className="h-8 w-8 rounded-full"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onClick();
          }}
        >
          <XCircleIcon className="h-8 w-8" />
        </button>
      </div>
    </div>
  );
};

export default ErrorDisplay;
